import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import { CODE_REQUEST } from '../../../../../../utility/SourceAPI'

export const getCodesHistory = createAsyncThunk('appCodesHistory/getCodesHistory', async () => {
    const response = await axios.get(CODE_REQUEST.concat('?all=true'))
    return {
        data: response.data
    }
})

export const createCodeRequest = createAsyncThunk('appCodesHistory/createCodeRequest', async (codeRequest, { dispatch }) => {
    const response = await axios.post(CODE_REQUEST, codeRequest)
    await dispatch(getCodesHistory())
    return response.data
})

export const deleteCodeRequest = createAsyncThunk('appCodesHistory/deleteCodeRequest', async (id, { dispatch }) => {
    const response = await axios.delete(`${CODE_REQUEST}${id}`)
    await dispatch(getCodesHistory())
    return response.data
})

export const updateStatusCodeRequest = createAsyncThunk('appCodesHistory/updateStatusCodeRequest', async ({  data }, { dispatch }) => {
    const response = await axios.put(`${CODE_REQUEST}restored_or_hostinger/${data.id}`, data)
    await dispatch(getCodesHistory())
    return response.data
})

export const updateCodeRequestByHostinger = createAsyncThunk('appCodesHistory/updateCodeRequestByHostinger', async ({ data }, { dispatch }) => {
    const response = await axios.put(`${CODE_REQUEST}hostinger_restored/${data.id}`, data)
    await dispatch(getCodesHistory())
    return response.data
})

export const codeRequestSlice = createSlice({
    name: 'appCodesHistory',
    initialState: {
        dataCodes: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getCodesHistory.fulfilled, (state, action) => {
            state.dataCodes = action.payload.data
        })
    }
})

export default codeRequestSlice.reducer